//
// forms/prefill.js -- prefill user details
//
// - Prefills a form from its StorageController
// - Note that for a particular field, progressive implies !prefill,
//   because progressive already prefills & also hides the element
//

import {data_store} from './data-store';
import * as value_extractor from './value-extractor';

const store = data_store();

export default function run_prefill(el_form) {
  if (!el_form.hasAttribute('data-prefill')) {
    return;
  }

  if (store === null) {
    console.log('run_prefill(): not running - data store could not be created');
    return;
  }

  const sel = '.c-form-set[data-prefill]' +
    ':not([data-progressive])' +
    ':not([data-cookie-source])' +
    ':not([data-type="hidden"])';
  const items = Array.from(el_form.querySelectorAll(sel));

  items.forEach(function(el_div) {
    const name = el_div.getAttribute('data-name');
    const value = store.get(name);
    if (value !== null) {
      value_extractor.set_value_div(el_div, value);
    }
  });
}

